import { mergeOverrides } from 'baseui'
import { FormControl } from 'baseui/form-control'
import type { FormControlOverrides } from 'baseui/form-control'
import { formControlOverrides, pulseFormControlOverrides } from '../styled-components'
import usePulseScope from '@/shared/components/PulseScope/usePulseScope'
import type { ReactNode } from 'react'

type SDFormControlProps = {
  hidden?: boolean
  plainLabel?: boolean
  overrides?: FormControlOverrides
  children: ReactNode
  [key: string]: any
}

const SDFormControl = ({ hidden, plainLabel = false, overrides, children, ...props }: SDFormControlProps) => {
  const isPulse = usePulseScope()

  if (hidden) return null

  const todayOverrides = plainLabel ? {} : formControlOverrides
  const newOverrides = mergeOverrides(isPulse ? pulseFormControlOverrides : todayOverrides, overrides ?? {})

  return (
    // @ts-ignore
    <FormControl overrides={newOverrides} {...props}>
      {children}
    </FormControl>
  )
}

export default SDFormControl
